module.exports = __webpack_public_path__ + "img/dsci0042.b71db4cd.jpg";